<template>
  <v-container>
    <app-loading :loading="loading">
      <div>
        <app-header :buttonAction="action" backButton :backAction="backAction">
          <template #title>{{ data.title }}</template>
          <template #subtitle>{{ data.subtitle }}</template>
        </app-header>
        <app-explanation v-intersect="onIntersect" class="my-9">
          <template #body>{{ data.description }}</template>
        </app-explanation>
        <app-button-player
          class="mt-7 mb-10"
          asPlayer
          :floating="!intersecting"
          short
          :src="data.audio_file"
        />
        <div v-show="!intersecting" style="height: 125px" />
        <v-row v-if="data.question_group">
          <v-col cols="12" sm="9" md="6">
            <app-rich-text v-model="answer.content" :src="student.avatar" :editable="!finished">
              <template #title>Type Here:</template>
              <template #button>
                <v-row justify="center" class="mt-6">
                  <v-btn
                    v-if="!finished"
                    small
                    depressed
                    width="100"
                    :loading="loadingFinish"
                    class="white--text text-capitalize"
                    color="#29284c"
                    @click="onFinish"
                    >Finish</v-btn
                  >
                  <ProgressResetButton
                    v-else
                    stepType="PRACTICE_TRANSCRIPT"
                    :stepUuid="data.uuid"
                    @reset="onReset"
                  />
                </v-row>
              </template>
            </app-rich-text>
          </v-col>
          <v-col cols="12" sm="9" md="6">
            <app-rich-text
              :hidden="!finished"
              :value="JSON.parse(data.question_group.questions[0].good_answer)"
              :editable="false"
            >
              <template #title>Transcript</template>
            </app-rich-text>
          </v-col>
        </v-row>
        <app-comment-group ref="commentGroup" :uuid="data.comment_group" />
      </div>
    </app-loading>
    <app-student-note v-if="!isTeacher && qualification.note" :note="qualification.note" />
    <app-qualification
      v-if="isTeacher && !qualification.note && qualification.uuid"
      :qualification="qualification"
      @new-qual="qualification = $event"
    />
  </v-container>
</template>
<script>
import Header from "@/components/Lessons/Lesson/components/Header.vue";
import Explanation from "@/components/Lessons/Lesson/components/Explanation.vue";
import RichText from "@/components/Lessons/Lesson/Exercise/RichText.vue";
import Loading from "@/components/Loading.vue";
import Qualification from "@/components/Utils/Qualification.vue";
import CommentGroup from "@/components/Lessons/Lesson/components/CommentGroup.vue";
import { getPracticeAudioTranscript, getAnswer, postAnswer, patchLessonProgress } from "@/api/api";
import studentMixin from "@/mixins/studentMixin";
import StudentNote from "@/components/Utils/StudentNote.vue";
import ButtonPlayer from "../ButtonPlayer.vue";
import ProgressResetButton from "@/components/Utils/ProgressResetButton.vue";

export default {
  components: {
    appHeader: Header,
    appExplanation: Explanation,
    appButtonPlayer: ButtonPlayer,
    appRichText: RichText,
    appLoading: Loading,
    appQualification: Qualification,
    appStudentNote: StudentNote,
    appCommentGroup: CommentGroup,
    ProgressResetButton,
  },
  mixins: [studentMixin],
  data() {
    return {
      finished: false,
      data: {},
      loading: true,
      loadingFinish: false,
      answer: {
        content: "",
      },
      qualification: {},
      intersecting: true,
    };
  },
  methods: {
    onIntersect(entries) {
      this.intersecting = entries[0].isIntersecting;
    },
    action() {
      this.$emit("next-step");

      const progress = this.$store.getters["progress/lesson"];
      if (!progress.practice_progress.audio_transcript_step) {
        progress.practice_progress.audio_transcript_step = true;
        patchLessonProgress(progress).then((response) => {
          this.$store.commit("progress/lesson", response.data);
        });
      }
    },
    onReset() {
      this.answer.content = "";
      this.answer.uuid = undefined;
      this.finished = false;
      this.$refs.commentGroup?.updateComments(this.data.comment_group);
    },
    async onFinish() {
      this.loadingFinish = true;
      if (!this.finished) {
        let answer = { ...this.answer };
        answer.content = JSON.stringify(answer.content);
        const response = await postAnswer(answer);
        if (response) {
          this.answer.uuid = response.data.uuid;
        }
        this.finished = true;
      }
      this.qualification = await this.qualify();
      this.loadingFinish = false;
    },
    backAction() {
      this.$emit("prev-step");
    },
  },
  async created() {
    this.loading = true;
    let response = await getPracticeAudioTranscript(
      this.$store.getters["lesson/practice"].audio_transcript_step,
    );
    this.data = response.data;

    response = await getAnswer({
      student__email: this.student.email,
      question__uuid: this.data.question_group.questions[0].uuid,
    });
    if (response.data.count) {
      [this.answer] = response.data.results;
      this.answer.content = JSON.parse(this.answer.content);
      this.finished = true;
    } else {
      this.answer.student = this.student.email;
      this.answer.question = this.data.question_group.questions[0].uuid;
      this.answer.content = JSON.parse(this.data.question_group.questions[0].content);
    }
    this.qualification = await this.fetchQualification(
      this.student.email,
      this.data.question_group.uuid,
    );

    this.loading = false;
  },
};
</script>
